import React, { useEffect } from "react";
import "./ArtisanList.css";
import axios from 'axios';

const ArtisanList = ({ artisans }) => {
  

  useEffect(() => {
    const trackImpressions = async () => {
      if (artisans && artisans.length > 0) {
        const trackingPromises = artisans.map(artisan => {
          if (!artisan || !artisan.id) return Promise.resolve();
          return axios.post(`${process.env.REACT_APP_SERVER_URL}/analytics/track`, {
            artisan_id: artisan.id,
            event_type: 'profile_impression'
          }).catch(error => console.error(`Failed to track impression for artisan ${artisan.id}`, error));
        });
        await Promise.all(trackingPromises);
      }
    };

    trackImpressions();
  }, [artisans]);

  const handleTrackClick = async (artisanId, eventType) => {
    if (!artisanId) return;
    try {
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/analytics/track`, {
        artisan_id: artisanId,
        event_type: eventType
      });
    } catch (error) {
      console.error(`Failed to track click for artisan ${artisanId}`, error);
    }
  };

  // If there are no artisans, display the message.
  if (!artisans || artisans.length === 0) {
    return <p>Aucun artisan trouvé.</p>;
  }

  return (
    <div className="artisan-list mt-4">
      <h4>Artisans recommandés :</h4>
      <div className="row">
        {artisans.map((artisan) => {
          // Add a defensive check to ensure the artisan object is valid before rendering
          if (!artisan || !artisan.id) {
            console.warn("Skipping invalid artisan object:", artisan);
            return null;
          }
          return (
            <div key={artisan.id} className="col-12 col-md-4 mb-4">
              <div className="card artisan-card h-100">
                <div className="card-body text-center d-flex flex-column">
                  {artisan.logo && (
                    <img
                      src={artisan.logo}
                      alt={artisan.name || 'Logo'}
                      className="artisan-logo mx-auto"
                    />
                  )}
                  {(artisan.rang === 0 || artisan.rang === 1) && (
                    <div className="artisan-badge-container">
                      <span
                        className={`badge ${
                          artisan.rang === 0
                            ? "bg-warning text-dark"
                            : "bg-primary"
                        } artisan-badge`}
                      >
                        {artisan.rang === 0
                          ? "Partenaire Premium"
                          : "Partenaire"}
                      </span>
                    </div>
                  )}
                  <h5 className="card-title mb-2">{artisan.name}</h5>
                  <p className="text-muted mb-2">{artisan.metier}</p>
                  {artisan.adresse && (
                    <p className="mb-3 small text-muted">
                      <i className="bi bi-geo-alt"></i> {artisan.adresse}
                    </p>
                  )}
                  <div className="mt-auto">
                    <div className="artisan-actions">
                      {artisan.site && (
                        <a
                          href={
                            artisan.site.startsWith("http")
                              ? artisan.site
                              : `https://${artisan.site}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary btn-sm flex-fill"
                          onClick={() => handleTrackClick(artisan.id, 'website_click')}
                        >
                          <i className="bi bi-globe"></i> Voir le site
                        </a>
                      )}
                      {artisan.email && (
                        <a
                          href={`mailto:${artisan.email}`}
                          className="btn btn-outline-secondary btn-sm flex-fill"
                          onClick={() => handleTrackClick(artisan.id, 'email_click')}
                        >
                          <i className="bi bi-envelope"></i> Email
                        </a>
                      )}
                    </div>
                    {artisan.telephone && (
                      <a
                        href={`tel:${artisan.telephone}`}
                        className="btn btn-success btn-sm mt-2 d-block"
                        onClick={() => handleTrackClick(artisan.id, 'phone_click')}
                      >
                        <i className="bi bi-telephone"></i> Appeler
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ArtisanList;
